export const CONTACT_ADDRESS = '4407 LAKE LAWNE AVENUE ORLANDO, FL. US 32808'
export const CONTACT_PHONE = '+1 (407) 205-4709'
export const CONTACT_EMAIL = "contact@digitalcoast.io"

export const CONTACT_LIST = [
  { icon: 'location-on', value: CONTACT_ADDRESS },
  // { icon: 'phone', value: CONTACT_PHONE },
  { icon: 'email', value: CONTACT_EMAIL }
]